module.exports = __webpack_public_path__ + "static/img/app.add70353.png";